export default function PersonStalker() {
  return (
    <div
      className="ion-icon-person-stalker"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M425.3,324.8c-41.4-15.7-38.9-9.4-38.9-38.5c0-18.8,9.3-11.9,15.2-47.7c2.3-14.1,4.2-4.7,9.1-27.3
		c2.6-11.8-1.8-12.7-1.2-18.3c0.5-5.6,1-10.7,2-22.2c1.2-14.4-11.6-52-57.4-52c-45.8,0-58.6,37.6-57.4,52c0.9,11.6,1.5,16.6,2,22.2
		c0.5,5.6-3.8,6.5-1.2,18.3c4.9,22.6,6.8,13.1,9.1,27.3c5.9,35.8,15.1,29,15.1,47.7c0,13.4,3.1,19-14.9,27.5
		c5.4,1.9,11.7,4.2,19.3,7.1c54.4,20.7,53.1,40.8,54.5,50.3c1,6.5,1.5,58.3,1.7,76.8H480c0,0,0-80.5-1.5-89.9
		C477.4,350.7,467.5,340.9,425.3,324.8z"/>
	<path d="M357,448c0,0,0-14.1-0.2-30.4c-0.2-18.6-0.7-40-1.7-46.4c-1.5-9.5-14.3-22.2-68.6-42.9c-7.5-2.8-13.8-5.1-19.3-7.1
		c-33.3-11.8-30.9-15.7-30.9-48c0-24.3,12-8.5,19.6-54.6c3-18.2,5.4-6.1,11.7-35.2c3.4-15.2-2.3-16.4-1.6-23.7
		c0.7-7.3,1.4-13.8,2.6-28.7c1.6-18.5-14.9-67.1-74.1-67.1c-59.2,0-75.6,48.5-74.1,67.1c1.2,14.9,1.9,21.4,2.7,28.7
		c0.7,7.3-5,8.4-1.6,23.7c6.4,29.1,8.8,17,11.8,35.2c7.6,46.1,19.5,30.3,19.5,54.6c0,37.6,3.3,34.8-50.2,55.1
		c-54.3,20.7-67.1,33.4-68.6,42.9C32,383.3,32,448,32,448h162.5H357z"/>
</g>
</svg>
`,
      }}
    />
  )
}
